<template>
    <v-toolbar :color="toolbarColor" dark dense elevation="0">
        <v-icon left>mdi-account-cog</v-icon>
        <v-toolbar-title>Permissions</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
export default {
    name: 'permissions-toolbar',
    computed: {
        toolbarColor() {
            return '#F64E60';
        }
    }
}
</script>